import { useMutation } from '@tanstack/react-query';

import { deleteAccount } from '../../../api/account';

export function useDeleteAccount() {
  return useMutation({ mutationFn: deleteAccount });
}
